import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AppraisalDocumentTypes,
  AppraisalManagersModel,
  FileTypes,
  OrNull,
  ValidationAppraisalDocumentTypes,
  ValidationAppraisalFilesIndexModel,
  ValidationAppraisalRegisteredPropertyModel,
} from '@foxeet/domain';
import { Observable } from 'rxjs';
import { CacheService } from '../services/cache.service';
import { WorkflowService } from '../services/workflow.service';
import { isNil } from '../to-delete/bucket';

@Injectable()
export class QualityControlService extends WorkflowService {
  constructor(http: HttpClient, cache: CacheService) {
    super(http, 'ValidationAppraisals', cache);
  }

  assignTechincal(appraisalId: number, technicalManagerUserId: number) {
    const body = { appraisalIds: [appraisalId], technicalManagerUserId };
    return this.put<typeof body, string>(`${appraisalId}/AssignTechnical`, body);
  }

  assignTechnicalManager(appraisalId: number, technicalManagerUserId: number) {
    const body = { appraisalIds: [appraisalId], TechnicalManagerUserId: technicalManagerUserId };
    return this.put<typeof body, string>(`${appraisalId}/AssignTechnicalManager`, body);
  }

  assignProcessManager(appraisalId: number, processManagerUserId: number) {
    // '/AssignProcessManager';
    const body = { appraisalIds: [appraisalId], processManagerUserId };
    return this.put<typeof body, string>(`${appraisalId}/AssignProcessManager`, body);
  }

  public appraisalValidationCreate(data: any, excelFile: Blob, pdfFile: Blob) /*: Observable<Prescriptor>*/ {
    const formData = new FormData();

    formData.append('recordId', data.recordId);
    formData.append('customerReferenceId', data.customerReferenceId);
    data.workflowItemLicensees.forEach((el: { [x: string]: any }, i: any) => {
      Object.keys(el).forEach((key) => formData.append(`workflowItemLicensees[${i}].${key}`, `${el[key]}`));
    });

    formData.append(`PdfFile`, pdfFile);
    formData.append(`ExcelFile`, excelFile);

    return this.postMultipartFile('', formData);
  }

  createWithFiles(data: FormData) {
    return this.postMultipartFile('', data);
  }

  startValidation(appraisalId: number) {
    // '/StartValidation';
    // const parameters: URLParameter[] = [{ key: 'AppraisalId', value: appraisalId }];
    return this.put(`${appraisalId}/StartValidation`);
  }

  succeedValidation(appraisalId: number) {
    // const parameters: URLParameter[] = [{ key: 'AppraisalId', value: appraisalId }];
    return this.put(`${appraisalId}/SucceededValidation`);
  }

  setAsDelivered(id: number) {
    // const parameters: URLParameter[] = [{ key: 'appraisalId', value: appraisalId }];
    return this.put(`${id}/Delivered`);
  }

  finishValidation(id: number) {
    // const parameters: URLParameter[] = [{ key: 'AppraisalId', value: AppraisalId }];
    return this.put(`${id}/FinishValidation`);
  }

  cancelValidation(id: number, data: any) {
    return this.put(`${id}/Cancel`, data);
  }

  public getManagers(id: number): Observable<AppraisalManagersModel> {
    return this.get<AppraisalManagersModel>(`${id}/Managers`);
  }

  public getRegisteredProperties(id: number): Observable<ValidationAppraisalRegisteredPropertyModel[]> {
    return this.get<ValidationAppraisalRegisteredPropertyModel[]>(`${id}/RegisteredProperties`);
  }

  public getDocuments(id: number): Observable<ValidationAppraisalFilesIndexModel[]> {
    return this.get<ValidationAppraisalFilesIndexModel[]>(`${id}/Documents`);
  }

  public createMassive(data: any, excelFile: Blob, pdfFiles: Blob[]) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => formData.append(key, data[key]));

    pdfFiles.forEach((file) => formData.append(`PdfFiles`, file));
    formData.append(`ExcelFile`, excelFile);

    return this.postMultipartFile('CreateMultiple', formData);
  }

  public uploadValidationAppraisalDocument(appraisalId: number, appraisalDocumentType: AppraisalDocumentTypes, document: Blob) {
    const formData = new FormData();
    formData.append('appraisalDocumentType', `${appraisalDocumentType}`);
    formData.append('file', document);
    return this.postMultipartFile(`${appraisalId}/Documents`, formData);
  }

  public uploadValidationAppraisalDocumentQuality(
    appraisalId: number,
    validationAppraisalDocumentType: ValidationAppraisalDocumentTypes,
    file: Blob,
    isPrintable: boolean,
    obtainedDatetime: OrNull<Date>,
  ) {
    const body = new FormData();
    body.append('File', file);
    body.append('appraisalDocumentType', `${validationAppraisalDocumentType}`);
    if (obtainedDatetime) {
      body.append('documentObtainedDate', `${obtainedDatetime.toISOString()}`);
    }
    return this.postMultipartFile(`${appraisalId}/Documents`, body);
  }

  getSimpleTemplateURL(): Observable<string> {
    return this.get(`SingleTemplate`, { responseType: 'text' });
  }

  getMassiveTemplateURL(): Observable<string> {
    return this.get('Template', { responseType: 'text' });
  }
}
